const locale = {
  xAxisTimeFormat: {
    year: '{MMM}, {yyyy}',
    month: '{MMM} {dd}',
    day: '{MMM} {dd}'
  }
};
export default locale;